const env = process.env.NODE_ENV;
const settings = {
  cookieTate: 7, // day
};
console.log(env);

if (env === 'development') {
  // settings.host = 'http://192.168.0.204:8380/his';
  // settings.host = 'http://b1.his.com/his';
  // settings.host = 'http://192.168.0.204:8080/his';
  // settings.host = 'http://192.168.0.206:8180/his';
  // settings.host = 'http://192.168.0.23:8080/his';
  // settings.host = 'http://192.168.0.89:8080/his';
  // settings.host = 'http://192.168.0.60:8080/api/his'; // 京燕
  // settings.host = 'http://192.168.0.99:8080/his'; // 刘伟
  // settings.host = 'http://192.168.0.33:8080/his'; // 小星
  settings.host = 'http://192.168.0.24:8080/his'; // 宁华
  // settings.host = 'http://192.168.0.10:8080/his'; // 彭岳
  // settings.host = 'http://192.168.0.20:8080/his'; // 周琴
  // settings.host = 'http://192.168.0.17:8080/his_ahs_war_exploded'; // 超尘
  // settings.host = '/api';
  // settings.host = 'http://allclinic.anheshou.com/his'; // 线上
  // settings.host = 'http://vip.anheshou.com/his'; // 线上
  // settings.host = 'http://his2.anheshou.com/his'; // 线上
  // settings.host = 'http://his.anheshou.com/his'; // 线上
  settings.db_prefix = 'dev_admin_';
} else if (env === 'mock') {
  settings.host = 'http://192.168.0.60:8080/api/his';
  settings.db_prefix = 'pos_admin_';
} else if (env === 'testDev') {
  // 测试环境
  settings.host = 'http://new.his.com/his';
  settings.db_prefix = 'test_admin_';
} else if (env === 'production') {
  // 生产环境
  settings.host = `http://${window.location.host}/his`;
  settings.db_prefix = 'pro_admin_';
} else {
  settings.host = 'http://new.his.com/his';
}

export default settings;
